<dialog
  #dialog
  qai-dialog
  [description]="''"
  [heading]="'Create new assignment'"
  (closeButtonClicked)="handleCloseModal()"
>
  <assignment-information-view
    *ngIf="form"
    [form]="form"
    [assignmentTypeOptions]="assignmentTypeOptions"
    [isNewAssignment]="true"
  ></assignment-information-view>

  <div class="action-button-container">
    <button
      qai-button
      kind="secondary"
      [size]="'medium'"
      [disabled]="this.form?.valid ? this.networkRequestInProgress : true"
      (click)="handleSaveAndCloseClick()"
    >
      Save and close
    </button>
    <button
      qai-button
      size="medium"
      kind="primary"
      [disabled]="this.form?.valid ? this.networkRequestInProgress : true"
      (click)="handleSuccessClick()"
    >
      Add simulations
    </button>
  </div>
</dialog>
